
import bugsnagClient from 'JS/global/bugsnag';
import Spinner from 'JS/components/Spinner.vue';
import VIntersectionObserver from 'JS/components/VIntersectionObserver.vue';
import Vue, { PropType } from 'vue';
import { ArticleSummary } from 'Src/js/types/Blog';
import { BlogService, IBlogService, PostQuery } from 'JS/services/BlogService';
import { Component, Inject, Prop } from 'vue-property-decorator';

@Component({
	name: 'BlogCarousel',
	components: {
		VIntersectionObserver,
		Spinner,
	}
})
class BlogCarousel extends Vue {
	@Prop({ type: String, required: true })
	title: string;

	@Prop({ type: String, required: false })
	smallTitle: string;

	@Prop({ type: String })
	viewAllLink: string;

	@Prop({ type: String })
	viewAllLinkAssistiveText: string;

	@Prop({ type: Object as PropType<PostQuery>, required: true })
	query: PostQuery;

	@Inject({ from: 'BlogService', default: () => new BlogService() })
	_blogService: IBlogService

	loadingState: 'loading' | 'error' | 'done' = 'loading';
	posts: ArticleSummary[] = [];

	async init() {
		try {
			this.posts = await this._blogService.getPosts(this.query);
			this.loadingState = 'done';
		} catch (e) {
			this.loadingState = 'error';
			bugsnagClient.notify(e, {
				metaData: {
					info: "failed to retrieve blog carousel"
				}
			});
		}
	}
}

export default BlogCarousel;

